import { Pager } from "../../domain/model/common";
import { FrontDate } from "../../domain/model/frontDate";
import {
  Occupation,
  PaymentRange,
  Place,
  Status,
  WorkingDuration,
  WorkingHourRange,
} from "../../domain/model/project";

// client project detail
interface IGetProjectDetailByClientRequest {
  projectId?: string;
}
class GetProjectDetailByClientRequest
  implements IGetProjectDetailByClientRequest
{
  public projectId: string;
}

interface ICreateProjectDetailByClientRequest {
  name?: string;
  description?: string;
  background?: string;
  preferentialExperience?: string;
  thumbnailURL?: string;
  place?: Place;
  workingHourRange?: WorkingHourRange;
  paymentRange?: PaymentRange;
  workingDuration?: WorkingDuration;
  occupations?: Occupation[];
  operatingDate?: FrontDate;
  isHideCompany?: boolean;
  uploadFileThumbnailURL?: File | null;
  status?: Status;
}
class CreateProjectDetailByClientRequest
  implements ICreateProjectDetailByClientRequest
{
  public name: string;
  public description: string;
  public background: string;
  public preferentialExperience: string;
  public thumbnailURL: string;
  public place: Place;
  public workingHourRange: WorkingHourRange;
  public paymentRange: PaymentRange;
  public workingDuration: WorkingDuration;
  public occupations: Occupation[];
  public operatingDate: FrontDate;
  public isHideCompany: boolean;
  public uploadFileThumbnailURL: File | null;
  public status: Status;
}

interface IUpdateProjectDetailByClientRequest {
  id?: string;
  name?: string;
  description?: string;
  background?: string;
  preferentialExperience?: string;
  thumbnailURL?: string;
  place?: Place;
  workingHourRange?: WorkingHourRange;
  paymentRange?: PaymentRange;
  workingDuration?: WorkingDuration;
  occupations?: Occupation[];
  status?: Status;
  operatingDate?: FrontDate;
  isHideCompany?: boolean;
  uploadFileThumbnailURL?: File | null;
}
class UpdateProjectDetailByClientRequest
  implements IUpdateProjectDetailByClientRequest
{
  public id: string;
  public name: string;
  public description: string;
  public background: string;
  public preferentialExperience: string;
  public thumbnailURL: string;
  public place: Place;
  public workingHourRange: WorkingHourRange;
  public paymentRange: PaymentRange;
  public workingDuration: WorkingDuration;
  public occupations: Occupation[];
  public status: Status;
  public operatingDate: FrontDate;
  public isHideCompany: boolean;
  public uploadFileThumbnailURL: File | null;
}

interface IDraftProjectDetailByClientRequest {
  projectId?: string;
}
class DraftProjectDetailByClientRequest
  implements IDraftProjectDetailByClientRequest
{
  public projectId: string;
}

interface IOpenProjectDetailByClientRequest {
  projectId?: string;
}
class OpenProjectDetailByClientRequest
  implements IOpenProjectDetailByClientRequest
{
  public projectId: string;
}

interface ICloseProjectDetailByClientRequest {
  projectId?: string;
}
class CloseProjectDetailByClientRequest
  implements ICloseProjectDetailByClientRequest
{
  public projectId: string;
}

// client project list

interface IGetAllProjectListByClientRequest {
  pager: Pager;
}
class GetAllProjectListByClientRequest
  implements IGetAllProjectListByClientRequest
{
  public pager: Pager;
}
interface ICopyProjectRequest {
  projectId: string;
}
class CopyProjectRequest implements ICopyProjectRequest {
  public projectId: string;
}

// customer project detail

interface IGetProjectByCustomerRequest {
  projectId?: string;
}
class GetProjectByCustomerRequest implements IGetProjectByCustomerRequest {
  public projectId: string;
}

interface ICreateEntryByCustomerRequest {
  projectId?: string;
}
class CreateEntryByCustomerRequest implements ICreateEntryByCustomerRequest {
  public projectId: string;
}

interface IDeleteEntryByCustomerRequest {
  projectId?: string;
}
class DeleteEntryByCustomerRequest implements IDeleteEntryByCustomerRequest {
  public projectId: string;
}

// customer project list
interface IGetEntryNumOrderProjectListByCustomerRequest {
  pager?: Pager;
}
class GetEntryNumOrderProjectListByCustomerRequest
  implements IGetEntryNumOrderProjectListByCustomerRequest
{
  public pager: Pager;
}

interface IGetProjectListByCustomerRequest {
  pager?: Pager;
}
class GetProjectListByCustomerRequest
  implements IGetProjectListByCustomerRequest
{
  public pager: Pager;
}

interface ISearchProjectListByCustomerRequest {
  page?: number;
  offset?: number;
  q?: string;
  occupation?: number;
  workingHourRange?: number;
  paymentRange?: number;
  workingDuration?: number;
  operatingDate?: FrontDate;
}
class SearchProjectListByCustomerRequest
  implements ISearchProjectListByCustomerRequest
{
  public page: number;
  public offset: number;
  public q: string;
  public occupation: number;
  public workingHourRange: number;
  public paymentRange: number;
  public workingDuration: number;
  public operatingDate: FrontDate;
}

export {
  CloseProjectDetailByClientRequest,
  CopyProjectRequest,
  CreateEntryByCustomerRequest,
  CreateProjectDetailByClientRequest,
  DeleteEntryByCustomerRequest,
  DraftProjectDetailByClientRequest,
  // client project list
  GetAllProjectListByClientRequest,
  // customer project list
  GetEntryNumOrderProjectListByCustomerRequest,
  // customer project detail
  GetProjectByCustomerRequest,
  // client project detail
  GetProjectDetailByClientRequest,
  GetProjectListByCustomerRequest,
  OpenProjectDetailByClientRequest,
  SearchProjectListByCustomerRequest,
  UpdateProjectDetailByClientRequest,
};



// WEBPACK FOOTER //
// ./src/presentation/request/project_request.ts